module.exports = __webpack_public_path__ + "assets/img/gar5-10.0bc75c81.jpg";